import { AvailabilityHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useWorkAvailabilities = (): AvailabilityHook => {
  const { availabilityStore } = useStore();
  const { workAvailabilities, loading } = availabilityStore;

  useEffect(() => {
    availabilityStore.getWorkAvailabilities();

    return () => availabilityStore.clearWorkAvailabilities();
  }, [availabilityStore]);

  return {
    availabilities: Array.from(workAvailabilities.values()),
    loading,
  };
};
